import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormAlertComponent } from './form-alert.component';

@NgModule({
  declarations: [FormAlertComponent],
  imports: [CommonModule, HttpClientModule, NgbModule],
  exports: [FormAlertComponent],
})
export class FormAlertModule {}
